/**
 * 学习页共享状态：当前选中章节（详情视图）
 * - 从 LearnPage 内部 state 提升到 store，供 App 顶栏渲染「← 返回」按钮（顶栏吸顶常驻）
 */
import { create } from 'zustand';

interface LearnState {
  /** 当前选中章节 id（null = 目录视图） */
  selectedId: number | null;
  select(id: number | null): void;
}

export const useLearnStore = create<LearnState>((set) => ({
  selectedId: null,
  select: (id) => set({ selectedId: id }),
}));
